module.exports = __webpack_public_path__ + "img/Recurso 8.9a04cd22.png";